@if (viewModel) {
    <section class="horses-race-resulted">
        <div class="result-container">
            <ul>
                <ms-resulted-placed-participants
                    [isOptionBet]="isOptionBet"
                    [participantOptionGroups]="viewModel.participantOptionGroups"
                    [participants]="viewModel.placed"
                    [prices]="prices" />
                <ms-resulted-placed-participants
                    [isOptionBet]="isOptionBet"
                    [isFavourites]="true"
                    [participantOptionGroups]="viewModel.participantOptionGroups"
                    [participants]="viewModel.favorites"
                    [prices]="prices" />
                <ms-resulted-non-runner-participants [participants]="viewModel.nonRunners" />
            </ul>
        </div>
        @if (viewModel.hasDividends) {
            <div class="dividend-header">{{ sitecore.horseRacing.raceResulted.Dividends }}</div>
        }
        @if (viewModel.hasDividends) {
            <div class="dividend-container">
                @for (dividend of viewModel.dividends; track $index) {
                    @if (dividend.available) {
                        <div class="dividend">
                            <div>{{ dividend.name }}</div>
                            <div>{{ dividend.value || '-' }}</div>
                        </div>
                    }
                }
            </div>
        }
    </section>
}
